import FileSaver from 'file-saver';
import React from 'react';
import { generateOrderEstimatePDF } from '@atlassian/temp-proxies';
import { GetOrderIntentEstimateRequestForPartnerOrderReview } from '@atlassian/cssxp-typescommon';
import { NotificationTypes, successNotificationBuilder, useNotification } from '@css-xp/base';
import { CheckoutOperation, usePartnerCheckoutNotification } from './use-place-order-notification';

export const useOrderEstimatePDFDownload = () => {
  const [isEstimatePDFDownloading, setIsEstimatePDFDownloading] = React.useState(false);
  const { notifyFailure } = usePartnerCheckoutNotification();
  const { notificationSent, sendSuccessNotification, setNotificationSent } = useNotification();

  let isPDFDownloaded = false;
  const downloadOrderEstimatePDF = async (requestPayload: GetOrderIntentEstimateRequestForPartnerOrderReview) => {
    setIsEstimatePDFDownloading(true);
    try {
      if (!notificationSent) {
        const notification = successNotificationBuilder()
          .isVersion(NotificationTypes.FLAG)
          .withHeader('Your estimate PDF is loading')
          .withMessage('This will just take a moment')
          .withDismissAfter(3000)
          .build();
        sendSuccessNotification(notification);
        setNotificationSent(true);
      }

      const pdfBlob = (await generateOrderEstimatePDF(requestPayload)) as Blob;
      const fileName = `Order-Estimate-${requestPayload.orderIntentId}.pdf`;
      FileSaver.saveAs(pdfBlob, fileName);
      isPDFDownloaded = true;
    } catch (_err: unknown) {
      // TODO: how to send a message to user?
      notifyFailure('Could not download PDF. Please try again in some time', CheckoutOperation.Others);
    } finally {
      setIsEstimatePDFDownloading(false);
    }
    return isPDFDownloaded;
  };

  return {
    downloadOrderEstimatePDF,
    isEstimatePDFDownloading,
  };
};
